import { Button, Group, Modal, Stack, Text } from "@mantine/core";
import React from "react";

interface GenericConfirmationModalProps {
  opened: boolean;
  onClose: () => void;
  title: string;
  text: React.ReactNode;
  onConfirm: () => void;
  confirmText?: string;
  cancelText?: string;
  action?: "accept" | "decline";
}

function GenericConfirmationModal(props: GenericConfirmationModalProps) {
  const confirmColor = props.action === "decline" ? "red" : "primary";

  return (
    <Modal
      opened={props.opened}
      onClose={props.onClose}
      title={props.title}
      centered
    >
      <Stack>
        {typeof props.text === "string" ? (
          <Text>{props.text}</Text>
        ) : (
          props.text
        )}
        <Group justify="flex-end" mt="md">
          <Button variant="outline" onClick={props.onClose}>
            {props.cancelText ?? "Cancel"}
          </Button>
          <Button color={confirmColor} onClick={props.onConfirm}>
            {props.confirmText ?? "Confirm"}
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}

export default GenericConfirmationModal;
